export enum IntakeDependentFeature {
  ClientProfile = "Client Profile",
  Billing = "Billing",
  VerifyInsurance = "Verify Insurance",
  Labs = "Labs",
}

export type IntakeDependencies = Record<string, IntakeDependentFeature[]>;

export interface RemovedDependentIntakeItem {
  linkId: string;
  label: string;
  features: IntakeDependentFeature[];
}
